import { h } from '@stencil/core';
import { i18n } from 'i18n';
import TermsItems from 'eva-components/TermsAndConditions/TermsItems';
import TermsButtons from 'eva-components/TermsAndConditions/Buttons';

export default function TermsAndConditionsModal({ show }: { show: boolean }) {
  return show ? (
    <div id="terms-and-conditions-modal" role="presentation" class="eva-3-modal -show-sticky-footer -smooth-scroll fullscreen-modal -show-modal">
      <div class="modal-header" role="presentation">
        <div class="modal-title-container">
          <h4 class="eva-3-h4 modal-title">{i18n.t.legal.termsAndConditions.title}</h4>
        </div>
      </div>
      <div class="modal-content" role="presentation">
        <TermsItems />
      </div>
      <div class="modal-footer">
        <TermsButtons size={'lg'} />
      </div>
    </div>
  ) : null;
}
